import React from 'react';
import {
  TouchableOpacity,
  View,
  StyleSheet,
  Text,
  Dimensions,
} from 'react-native';
import FontAwesome5Pro from 'react-native-vector-icons/FontAwesome5Pro';
import AVFormattedCurrency from '../AVFormattedCurrency';
import Styles from '../../Styles';

type SearchProductProps = {
  imageUrl?: string;
  name: string;
  price: number;
  onPress: () => void;
};
const imageHeight = Dimensions.get('screen').height * 0.2;

const SearchProduct = (props: SearchProductProps) => (
  <TouchableOpacity onPress={props.onPress}>
    <View style={styles.container}>
      <View style={styles.cellContent}>
        <View style={styles.mainCellContent}>
          <Text style={styles.productName}>{props.name}</Text>
          <AVFormattedCurrency
            style={styles.productPrice}
            value={props.price}
            accessibilityLabel="itemPrice"
          />
        </View>
        <TouchableOpacity onPress={props.onPress}>
          <FontAwesome5Pro
            name="chevron-right"
            color={Styles.auxColor}
            size={Styles.Fonts.f2}
            light
          />
        </TouchableOpacity>
      </View>
    </View>
  </TouchableOpacity>
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  cellContent: {
    flexDirection: 'row',
    borderBottomColor: Styles.bgColor,
    borderBottomWidth: 1,
    alignItems: 'center',
    paddingVertical: Styles.Spacing.m2,
    paddingHorizontal: Styles.Spacing.m3,
  },
  mainCellContent: {
    flex: 1,
    justifyContent: 'space-between',
  },
  productName: {
    fontSize: Styles.Fonts.f1,
    fontWeight: '600',
  },
  productPrice: {
    fontSize: Styles.Fonts.f0,
    color: Styles.gray40,
  },
  productImage: {
    resizeMode: 'contain',
    height: imageHeight,
    width: undefined,
  },
  imageContainer: {
    backgroundColor: Styles.imageBackground,
    width: '100%',
  },
});

export default SearchProduct;
